// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W7gID","title":"styles_title__1oVt4"};